import { render, staticRenderFns } from "./RecaptchaText.vue?vue&type=template&id=3bc18060&"
import script from "./RecaptchaText.vue?vue&type=script&lang=js&"
export * from "./RecaptchaText.vue?vue&type=script&lang=js&"
import style0 from "./RecaptchaText.vue?vue&type=style&index=0&id=3bc18060&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports